export default __webpack_public_path__ + "assets/media/favicon96.d5e04d6fed7bb447bc9e2047b73a36ba.png";